import { createReducer, on } from '@ngrx/store';

import { ReviewActions } from '@ren/features/review/state/actions';
import { ReviewActionsUnion } from '@ren/features/review/state/actions/review.actions';

import { YourQuoteSummary } from '@ren/features/review/interfaces/your-quote-summary';
import { YourCarSummary } from '@ren/features/review/interfaces/your-car-summary';
import { YourAddressSummary } from '@ren/features/review/interfaces/your-address-summary';
import { YourDetailsSummary } from '@ren/features/review/interfaces/your-details-summary';
import { YourDrivingHistorySummary } from '@ren/features/review/interfaces/your-driving-history-summary';
import { YourAdditionalDriversSummary } from '@ren/features/review/interfaces/your-additional-drivers-summary';
import { YourDiscountsSummary } from '@ren/features/review/interfaces/your-discounts-summary';
import { YourCoverSummary } from '@ren/features/review/interfaces/your-cover-summary';
import { YourPaymentsSummary } from '@ren/features/review/interfaces/your-payments-summary';
import { BookletCodes } from '@ren/features/review/interfaces/booklet-codes';
import { PaymentOptions } from '@ren/features/review/interfaces/payment-options';

export interface ReviewState {
  yourQuoteSummary: YourQuoteSummary;
  yourCarSummary: YourCarSummary;
  yourAddressSummary: YourAddressSummary;
  yourDetailsSummary: YourDetailsSummary;
  yourDrivingHistorySummary: YourDrivingHistorySummary;
  yourAdditionalDriversSummary: YourAdditionalDriversSummary[];
  yourDiscountsSummary: YourDiscountsSummary;
  yourCoverSummary?: YourCoverSummary;
  yourPaymentsSummary?: YourPaymentsSummary;
  bookletCodes?: BookletCodes;
  paymentOptions?: PaymentOptions;
}

export const initialState: ReviewState = {
  yourQuoteSummary: null,
  yourCarSummary: null,
  yourAddressSummary: null,
  yourDetailsSummary: null,
  yourDrivingHistorySummary: null,
  yourAdditionalDriversSummary: null,
  yourDiscountsSummary: null,
  yourCoverSummary: null,
  yourPaymentsSummary: null,
  bookletCodes: null,
  paymentOptions: null
};

export const reviewReducer = createReducer(
  initialState,
  on(ReviewActions.loadReviewDetails, (state, {reviewDetails}) => ({...state, ...reviewDetails})),
  on(ReviewActions.updatePaymentOptions, (state, {paymentOptions}) => ({...state, paymentOptions}))
);

export function reducer(state: ReviewState | undefined, action: ReviewActionsUnion) {
  return reviewReducer(state, action);
}
